import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-heart-filled",
  "use": "icon-heart-filled-usage",
  "viewBox": "-2 -2 40 40",
  "content": "<symbol viewBox=\"-2 -2 40 40\" id=\"icon-heart-filled\"><path d=\"M24.4,0c-2.3,0-4.5,0.8-6.2,2.3L17,3.2l-1.1-0.9C14.2,0.8,11.9,0,9.6,0C4.3,0,0,4.3,0,9.7c0,1.4,0,4.6,2.1,8.7 c2.6,5,7.4,9.5,14.4,13.3L17,32l0.5-0.3c6.9-3.9,11.8-8.3,14.4-13.3C34,14.3,34,11,34,9.6v0C34,4.3,29.7,0,24.4,0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/heart-filled.svg
// module id = 1128
// module chunks = 2